module.exports = __webpack_public_path__ + "img/table-notes-icon.25b1f8f0.svg";